module.exports = __webpack_public_path__ + "WorkSans-ExtraLight.43d14eda77c451857e34.ttf";


//////////////////
// WEBPACK FOOTER
// D:/F210-INGRESO/cambio_enlace_ayuda/rec_ng_ingresorenta210/src/assets/fonts_v2/Work_Sans/WorkSans-ExtraLight.ttf
// module id = ../../../../../src/assets/fonts_v2/Work_Sans/WorkSans-ExtraLight.ttf
// module chunks = styles